import PaymentTypes from '../types/PaymentTypes';

const initialState = {
  isLoading: false,
  paymentData: [],
  paymentfilterData: {},
  paymentItemData: {},
  invoiceNumberData: null,
  paymentMethodData: [],
  paymentTypeData: [],
  transactionData: [],
  transItemData: [],
  transactionStatus: [],
  paymentInfo: {},
  paypalData: [],
  pendingPaymentData: {},
  manualData: [],
  manualItemData: {},
  manualfilterData: [],
  manualQueryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    payMethod: '',
    payType: '',
    keyword: '',
    rangeDateData: [null, null]
  },
  paymentStatus: {}
};

// eslint-disable-next-line default-param-last
const payment = (state = initialState, action) => {
  switch (action.type) {
    case PaymentTypes.GET_PAYMENT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentData: action.payload,
        invoiceNumberData: null
      };
    case PaymentTypes.GET_PAYMENT_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentData: []
      };

    case PaymentTypes.GET_INVOICE_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_INVOICE_FILTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentfilterData: action.payload
      };
    case PaymentTypes.GET_INVOICE_FILTER_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentfilterData: {}
      };

    case PaymentTypes.GET_PAYMENT_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentItemData: action.payload,
        invoiceNumberData: null
      };
    case PaymentTypes.GET_PAYMENT_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentItemData: []
      };

    case PaymentTypes.GET_INVOICE_NUMBER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_INVOICE_NUMBER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invoiceNumberData: action.payload
      };
    case PaymentTypes.GET_INVOICE_NUMBER_ERROR:
      return {
        ...state,
        isLoading: false,
        invoiceNumberData: null
      };
    case PaymentTypes.GET_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentMethodData: action.payload
      };
    case PaymentTypes.GET_PAYMENT_METHOD_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentMethodData: []
      };
    case PaymentTypes.GET_PAYMENT_REQUEST_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_REQUEST_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentTypeData: action.payload
      };
    case PaymentTypes.GET_PAYMENT_REQUEST_TYPE_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentTypeData: []
      };

    case PaymentTypes.GET_ALL_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_ALL_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transactionData: action.payload
      };
    case PaymentTypes.GET_ALL_TRANSACTION_ERROR:
      return {
        ...state,
        isLoading: false,
        transactionData: []
      };

    case PaymentTypes.GET_TRANSACTION_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_TRANSACTION_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transItemData: action.payload
      };
    case PaymentTypes.GET_TRANSACTION_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        transItemData: []
      };

    case PaymentTypes.GET_TRANSACTION_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_TRANSACTION_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transactionStatus: action.payload
      };
    case PaymentTypes.GET_TRANSACTION_STATUS_ERROR:
      return {
        ...state,
        isLoading: false,
        transactionStatus: []
      };
    case PaymentTypes.GET_PAYMENT_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentInfo: action.payload
      };
    case PaymentTypes.GET_PAYMENT_DETAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentInfo: {}
      };
    case PaymentTypes.GET_GENERATE_PAYPAL_REQUEST:
      return {
        ...state,
        isLoading: false
      };
    case PaymentTypes.GET_GENERATE_PAYPAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paypalData: action.payload
      };
    case PaymentTypes.GET_GENERATE_PAYPAL_ERROR:
      return {
        ...state,
        isLoading: false,
        paypalData: []
      };
    case PaymentTypes.GET_PAYMENT_PENDING_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_PENDING_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pendingPaymentData: action.payload
      };
    case PaymentTypes.GET_PAYMENT_PENDING_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        pendingPaymentData: {}
      };

    // ---------
    case PaymentTypes.GET_MANUAL_PAYMENT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manualData: action.payload
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        manualData: []
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manualItemData: action.payload
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        manualItemData: []
      };

    case PaymentTypes.GET_MANUAL_PAYMENT_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_FILTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manualfilterData: action.payload
      };
    case PaymentTypes.GET_MANUAL_PAYMENT_FILTER_ERROR:
      return {
        ...state,
        isLoading: false,
        manualfilterData: []
      };
    case PaymentTypes.UPDATE_MANUAL_QUERY_PARAMS:
      return {
        ...state,
        manualQueryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paging,
          sortingData: action.payload.sorting,
          keyword: action.payload.keyword,
          payMethod: action.payload.method,
          payType: action.payload.type,
          rangeDateData: action.payload.rangeDate
        }
      };
    case PaymentTypes.GET_PAYMENT_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentStatus: action.payload
      };
    case PaymentTypes.GET_PAYMENT_STATUS_ERROR:
      return {
        ...state,
        isLoading: false,
        paymentStatus: {}
      };
    case PaymentTypes.GET_SCHEDULE_CANCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PaymentTypes.GET_SCHEDULE_CANCEL_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case PaymentTypes.GET_SCHEDULE_CANCEL_ERROR:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};
export default payment;
